import { useParams, useNavigate } from "react-router-dom";
import ProjectWorkspace from "../../components/admin/ProjectWorkspace";
import { useLang } from "../../context/LanguageContext";

// Fiche dossier ouverte depuis la liste « Demandes » : même espace de travail
// complet que celui de « Projets par utilisateur », avec retour vers la liste.
export default function AdminProjectDetail() {
  const { pid } = useParams();
  const nav = useNavigate();
  const { tf: t } = useLang();
  return <ProjectWorkspace pid={pid} backLabel={t("apd_back")} onBack={() => nav("/admin/projets")} />;
}
